import { useMemo } from "react";
import { useSelector } from "react-redux";
import Grid from "../fragments/Grid";

import classes from './widgets/DashboardItem.module.css'
import TransfersWidget from "./widgets/transfers/TransfersWidget";
import TasksWidget from "./widgets/tasks/TasksWidget";
import TasksSummaryWidget from "./widgets/taskssummary/TasksSummaryWidget";
import WorkQWidgetsWrapper from "./widgets/workqwidget/WorkQWidgetsWrapper";
import MyLocations from "./MyLocations";

export default function DashboardLanding() {
    const editPermissions = useSelector(state => state.permissions.editPermissions)
    const canViewTransfers = !!editPermissions?.practice_view_transfer

    const dashboardData = useMemo(() => {
        const widgets = [
            {
                id: 11,
                component: <TasksSummaryWidget />,
                full: true,
                nobackground: true
            },
            {
                id: 1,
                component: <WorkQWidgetsWrapper />,
                full: true,
                nobackground: true
            },
            {
                id: 12,
                component: <TasksWidget />,
                full: true
            },
        ]

        if (canViewTransfers) {
            widgets.push({
                id: 10,
                component: <TransfersWidget />,
                full: true
            })
        }

        return widgets
    }, [canViewTransfers])

    return <>
        <MyLocations />
        <Grid columns={2} margin='top'>
            {dashboardData && dashboardData.map(item => (
                <div key={item.id} className={`${classes.item} ${item.full ? classes.item_full : ''} ${item.nobackground ? classes.item_nobackground : ''}`}>{item.component}</div>
            ))}
            {/* <DashboardAddMoreWidgets /> */}
        </Grid>
    </>
}
